import React from 'react';
import Autocomplete from 'react-autocomplete';

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
};

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

const ThirdStep = props => (
  <div className='fdvEquip-slides-item simpleSlide active'>
    <h6 className='h5 mb-4'><span className='bold'>N° Pedidos</span><br/>
    {props.pedidosEquiposAdicionales.map((pedido, id) => (

        pedido.status !== 0 ? (<span key={id} >{pedido + ' ' }</span>
        ) : null
      ))}
    </h6>
    <p className='labelInfo'>Adicionales</p>
    <div className='hidden-xs' >
      <div className='tableWrapper'>
        <table className='table table-hover'>
          <thead className='table-head'>
            <tr>
              <th>SKU</th>
              <th>Equipo Localss</th>
              <th>Cantidad</th>
              <th>Precio</th>
            </tr>
          </thead>
          <tbody>
          {props.equiposProveedorSeleccionado.sort(function (a, b) {
                      if (a.codEquipo > b.codEquipo) {
                        return 1;
                      }
                      if (a.codEquipo < b.codEquipo) {
                        return -1;
                      }
                      return 0;
        }).map((equipos,id) =>(

            <tr key={id}>
              <td>{equipos.codEquipo}</td>
              <td>{equipos.descEquipo}</td>
              <td>
                <div className='stepper'>
                  <div className='stepper-control'>
                    <i className='ion-android-remove stepper-control-minus'
                     onClick = {()=> props.adicionRestasEquiposAdicionales(equipos.codEquipo,0,3)}
                    ng-init='countsearchStepper0 = 0' />
                    <input id={'inputEquipo' +id} className='stepper-control-number' value={equipos.cantidad} readOnly name='searchStepper0' /><i className='ion-android-add stepper-control-plus'
                     onClick = {()=> props.adicionRestasEquiposAdicionales(equipos.codEquipo,1,3)}/>
                  </div>
                  <label className='error' generated='true' htmlFor='searchStepper0' />
                </div>
              </td>
              <td id={'td' +id} >{equipos.precio*equipos.cantidad}</td>
      			  <td><i className='ion-trash-a h6 c-cyan h6' onClick = {()=> props.eliminateAdditionalEquipment(equipos.codEquipo)} /></td>
            </tr>

          ))}
          </tbody>
        </table>
      </div>
    </div>


    <hr className='modalBleed' />
    <div className='form-group'>
      <div className='form-group'>
        <label className='labelInfo'>Observaciones</label>
        <textarea name="observacionEquipoAdicionales" value={props.observacionEquipoAdicionales} onChange={props.onChangeInput} className='form-control' /><span className='error'>Mensaje de error</span>
      </div>
    </div>
    <div className='form-group'>
    <div className='pillSelct'>
        <p className='labelInfo'>Notificar a un colaborador</p>
        <div className='pillSelct-field'>
          <div className='awesomplete'>
            <Autocomplete
              getItemValue={item => item.idUsuario.toString()}
              value={props.colaborador}
              items={props.colaboradores}
              renderItem={(item, isHighlighted) =>
                <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                  {`${item.apellidos} ${item.nombre}`}
                </div>
              }
              onChange={props.changeColaborador}
              menuStyle={menuStyle}
              inputProps={inputProps}
              wrapperStyle={{ display: 'block' }}
              onSelect={props.selectColaborador}
            />
          </div>
          <div className='pillSelct-pills'>
            {
              props.colaboradoresSeleccionados.map((colaborador, idColaborador) => (
                <label key={idColaborador} className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                  {colaborador.nombres}
                  <button
                    className='pillSelct-delete'
                    onClick={() => props.removeColaborador(colaborador.id)}
                  ><i className='icon ion-close pill-close' />
                  </button>
                </label>
              ))
            }
          </div>

        </div>
      </div>

    </div>
    <div className='modal-actions'>
      <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
      <button className='btn btn-primary pull-right' onClick = {() => props.guardarAplicarAdicionales()} >Aplicar adicionales</button>
    </div>

  </div>


);

export default ThirdStep;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/EquiposLogistica/AgregarEquiposAdicionales/ThirdStep.js